export default {"src":"/_next/static/media/support-icon.aac7bb16.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};